export default "__VITE_ASSET__CbTyBvJI__"